import { Link, useLocation } from "react-router-dom";
import { Github, Linkedin, Mail } from "lucide-react";
import { ShaderBackground, AnimatedRoutes } from "../../components";
import styles from "./RootLayout.module.css";

// const NAV_ITEMS: any = [
  // { label: "Work", to: "/work" },
  // { label: "Notes", to: "/notes" },
  // { label: "Résumé", to: "/resume.pdf", external: true },
// ];

const SOCIAL_LINKS = [
  { label: "Email", href: "mailto:hi@angusdowli.ng", icon: Mail },
  { label: "GitHub", href: "https://github.com/angusdowling", icon: Github },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/angus-dowling/",
    icon: Linkedin,
  },
];

export function RootLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isWork = location.pathname === "/work";
  const isNotes = location.pathname === "/notes";
  const isNote = location.pathname.startsWith("/notes/");

  const getLayoutClass = () => {
    if (isHome || isWork || isNotes) return styles.mainOverlay;
    if (isNote) return styles.mainNote;
    return styles.mainStacked;
  };

  return (
    <div className={`${styles.main} ${getLayoutClass()}`}>
      <header className={styles.header}>
        <h1 className={styles.title}>
          <Link to="/">Angus Dowling</Link>
        </h1>

        <nav>
          <ul className={styles.nav}>
            {/* {NAV_ITEMS.map(({ label, to, external }) => (
              <li key={to}>
                {external ? (
                  <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.navLink}
                  >
                    {label}
                  </a>
                ) : (
                  <NavLink
                    to={to}
                    className={({ isActive }) =>
                      `${styles.navLink} ${
                        isActive ? styles.navLinkActive : ""
                      }`
                    }
                  >
                    {label}
                  </NavLink>
                )}
              </li>
            ))} */}
          </ul>
        </nav>
      </header>

      <main>
        <div className={styles.frame}>
          <ShaderBackground />
        </div>

        <div className={styles.content}>
          <AnimatedRoutes />
        </div>
      </main>

      <footer className={styles.footer}>
        <p className={styles.footerText}>
          Software Engineer <br /> based in Australia
        </p>
        <ul className={styles.socialLinks}>
          {SOCIAL_LINKS.map(({ label, href, icon: Icon }) => (
            <li key={href}>
              <a
                href={href}
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon size={20} strokeWidth={1} />
              </a>
            </li>
          ))}
        </ul>
      </footer>
    </div>
  );
}
